import { Injectable, Inject} from '@angular/core';
import {PolicyCoverageInsuredDO} from '../policyCoverageInsured.model';
import {PolicyCoverageScheduleDO} from '../PolicyCoverageSchedule.model';
import {BaseDO} from '../base.model';

export  class PolicyCoverageDO extends BaseDO{
    // public sumInsured:string;
    // public premium:string;
    // public planType:string;
    // public policyCoverageInsuredList: PolicyCoverageInsuredDO[];
    public  id:Number = null;
	
	public  planTypeCd:String = null;

	public  productCd:String = null;

	public productTypeCd:String=null;
	
	public  productVersion:Number = null;
	
	public  associationType:String = null;
	
	public  planOptionCd:String = null;
	
	public  sumInsured:Number = null;

	public  estimatedSumInsured:Number = null;
	
	public  totalPremium:Number = null;
	
	public  totalExtraPremium:Number = null;
	
	public  baseAnnualPremium:Number = null;
	
	public  baseModalPremium:Number = null;
	
	public  premiumRate:Number = null;
	
	public  term:Number = null;
	
	public  commencementDt:Date = null;
	
	public  expiryDt:Date = null;
	
	public  paymentMethodCd:String = null;
	
	public  paymentFrequencyCd:String = null;
	
	public  paymentTerm:String = null;
	
	public  uwDecisionCd:String = null;
	
	public  uwDecisionValue:String = null;
		
	public  coverageUIProperty:String = null;
	
	public  coverageUIPropertyValue:String = null;
	
	public ratingTypeCd:String=null;
	
	public primaryInsuredValue:Number=null;

	public totOtherInsurableValue:Number=null;

	public sortOrder: Number =null;
	
	public  policyCoverageInsuredList:PolicyCoverageInsuredDO[] = [];
	
	public  policyCoverageScheduleList:PolicyCoverageScheduleDO[] = [];
		
	public  policyCoverageAdditionalFieldDOs = null;

	public  setId( id) {
		this.id = id;
	}
	public  getCoverageUIProperty() {
		return this.coverageUIProperty;
	}

	public  setCoverageUIProperty( coverageUIProperty) {
		this.coverageUIProperty = coverageUIProperty;
	}
	public  getCoverageUIPropertyValue() {
		return this.coverageUIPropertyValue;
	}
	public  setCoverageUIPropertyValue( coverageUIPropertyValue) {
		this.coverageUIPropertyValue = coverageUIPropertyValue;
	}
	
	// public  setId() {
	// 	return this.id;
	// }
	public  getProductCd() {
		return this.productCd;
	}

	public  setProductCd( productCd) {
		this.productCd = productCd;
	}

	public  getProductVersion() {
		return this.productVersion;
	}

	public  setProductVersion( productVersion) {
		this.productVersion = productVersion;
	}

	public  getPlanOptionCd() {
		return this.planOptionCd;
	}

	public  setPlanOptionCd( planOptionCd) {
		this.planOptionCd = planOptionCd;
	}

	public  getBaseAnnualPremium() {
		return this.baseAnnualPremium;
	}

	public  setBaseAnnualPremium( baseAnnualPremium) {
		this.baseAnnualPremium = baseAnnualPremium;
	}

	public  getBaseModalPremium() {
		return this.baseModalPremium;
	}

	public  setBaseModalPremium( baseModalPremium) {
		this.baseModalPremium = baseModalPremium;
	}

	public  getTotalExtraPremium() {
		return this.totalExtraPremium;
	}

	public  setTotalExtraPremium( totalExtraPremium) {
		this.totalExtraPremium = totalExtraPremium;
	}



	public  getTotalPremium() {
		return this.totalPremium;
	}

	public  setTotalPremium( totalPremium) {
		this.totalPremium = totalPremium;
	}


	public  getPaymentMethodCd() {
		return this.paymentMethodCd;
	}

	public  setPaymentMethodCd( paymentMethodCd) {
		this.paymentMethodCd = paymentMethodCd;
	}

	public  getPaymentFrequencyCd() {
		return this.paymentFrequencyCd;
	}

	public  setPaymentFrequencyCd( paymentFrequencyCd) {
		this.paymentFrequencyCd = paymentFrequencyCd;
	}

	public  getPaymentTerm() {
		return this.paymentTerm;
	}

	public  setPaymentTerm( paymentTerm) {
		this.paymentTerm = paymentTerm;
	}

	public  getSumInsured() {
		return this.sumInsured;
	}

	public  setSumInsured( sumInsured) {
		this.sumInsured = sumInsured;
	}

	public getPolicyCoverageInsuredList() {
		return this.policyCoverageInsuredList;
	}

	public  setPolicyCoverageInsuredList(policyCoverageInsuredList) {
		this.policyCoverageInsuredList = policyCoverageInsuredList;
	}

	public  getId() {
		return this.id;
	}

	public  getUwDecisionCd() {
		return this.uwDecisionCd;
	}

	public  setUwDecisionCd( uwDecisionCd) {
		this.uwDecisionCd = uwDecisionCd;
	}

	public  getUwDecisionValue() {
		return this.uwDecisionValue;
	}

	public  setUwDecisionValue( uwDecisionValue) {
		this.uwDecisionValue = uwDecisionValue;
	}

	public  getPolicyCoverageAdditionalFieldDOs() {
		return this.policyCoverageAdditionalFieldDOs;
	}

	public  setPolicyCoverageAdditionalFieldDOs(
			policyCoverageAdditionalFieldDOs) {
		this.policyCoverageAdditionalFieldDOs = policyCoverageAdditionalFieldDOs;
	}

	public  getPlanTypeCd() {
		return this.planTypeCd;
	}

	public  setPlanTypeCd( planTypeCd) {
		this.planTypeCd = planTypeCd;
	}

	public  getAssociationType() {
		return this.associationType;
	}
	public  setAssociationType( associationType) {
		this.associationType = associationType;
	}
	public  getPremiumRate() {
		return this.premiumRate;
	}
	public  setPremiumRate( premiumRate) {
		this.premiumRate = premiumRate;
	}
	public  getEstimatedSumInsured() {
		return this.estimatedSumInsured;
	}
	public  setEstimatedSumInsured( estimatedSumInsured) {
		this.estimatedSumInsured = estimatedSumInsured;
	}

	// public  getObjectName() {
	// 	if(planTypeCd.equals("BASEPLAN")){
	// 		return this.planTypeCd;
	// 	}else{
	// 		return this.PolicyCoverageDO.class.getSimpleName();
	// 	}
	// }
	
	// public  FormattedSumInsured(){
	// 	return this.sumInsured.to();
	// }
	public  getTerm() {
		return this.term;
	}
	public  setTerm( term) {
		this.term = term;
	}
	public  getCommencementDt() {
		return this.commencementDt;
	}
	public  setCommencementDt( commencementDt) {
		this.commencementDt = commencementDt;
	}
	public  getExpiryDt() {
		return this.expiryDt;
	}
	public  setExpiryDt( expiryDt) {
		this.expiryDt = expiryDt;
	}

}
